import { Input } from "antd"
import immer from "immer"
import { MmuDataType, MmuModeType } from "libs/enums"
import { useEffect, useState } from "react"
import { CheckButton } from "./CheckButton"

type SkuCategoryAttributeDTO = SkuDetail.SkuCategoryAttributeDTO
type SkuCategoryAttributeValueDTO = SkuDetail.SkuCategoryAttributeValueDTO

type ProductDetailAttributeProps = {
  attribute: SkuCategoryAttributeDTO
  isMmu: boolean
  onChange: Function
}
export default function ProductDetailAttribute({
  attribute,
  isMmu,
  onChange,
}: ProductDetailAttributeProps) {
  const [inputVal, setInputVal] = useState(null)

  useEffect(() => {
    const newInputVal =
      attribute.categoryAttributeValueList?.[0]?.attributeValue
    if (inputVal !== newInputVal) {
      setInputVal(newInputVal)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attribute.categoryAttributeValueList?.[0]?.attributeValue])

  function isRadio() {
    if (isMmu) {
      return !attribute.hasCustomize && attribute.modeType === MmuModeType.RADIO
    } else {
      return true
    }
  }

  function isCheckbox() {
    return (
      !attribute.hasCustomize && attribute.modeType === MmuModeType.CHECKBOX
    )
  }

  function isTEXT() {
    return attribute.hasCustomize && attribute.dataType === MmuDataType.TEXT
  }

  function isFloat() {
    return attribute.hasCustomize && attribute.dataType === MmuDataType.FLOAT
  }
  function isInt() {
    return attribute.hasCustomize && attribute.dataType === MmuDataType.INT
  }

  function handleClickRadio(
    attribute: SkuCategoryAttributeDTO,
    attr: SkuCategoryAttributeValueDTO,
    curIndex: number,
  ) {
    if (isMmu) {
      if (attr.active) {
        if (attribute.hasRequired) return
        const newAttr = immer(attribute, (draft) => {
          draft.categoryAttributeValueList[curIndex].active = false
        })
        onChange(newAttr)
      } else {
        const newAttr = immer(attribute, (draft) => {
          draft.categoryAttributeValueList.forEach((v, index) => {
            v.active = index === curIndex
          })
        })
        onChange(newAttr)
      }
    } else {
      if (attr.active) {
        if (attr.cancelAttributeSkuSysNo !== null) {
          onChange({ sysNo: attr.cancelAttributeSkuSysNo })
        }
      } else {
        onChange({ sysNo: attr.skuSysNo })
      }
    }
  }

  function handleClickCheckbox(curIndex) {
    const newAttr = immer(attribute, (draft) => {
      draft.categoryAttributeValueList.forEach((v, index) => {
        if (index === curIndex) {
          v.active = !v.active
        }
      })
    })
    onChange(newAttr)
  }

  function handleChangeInput(val: any, attr: SkuCategoryAttributeValueDTO) {
    val = isFloat()
      ? val.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, "$1")
      : val?.trim()
    // attr.attributeValue = val
    setInputVal(val)
  }

  function handleBlur() {
    const newAttr = immer(attribute, (draft) => {
      draft.categoryAttributeValueList[0].attributeValue = inputVal
      draft.categoryAttributeValueList[0].active =
        inputVal != null && inputVal != ""
    })
    onChange(newAttr)
  }

  function inputType() {
    if (isFloat()) {
      return "number"
    } else if (isInt()) {
      return "digit"
    } else {
      return "text"
    }
  }

  return (
    <div className="item-wrap">
      <div className="item-label">{attribute.attributeName}:</div>
      <div className="item-content">
        {isRadio() && (
          <div className="item-content-radio-wrap">
            {attribute.categoryAttributeValueList?.map((attr, attrIndex) => (
              <div className="radio-item" key={attrIndex}>
                <CheckButton
                  name={attr.attributeValue}
                  active={attr.active}
                  choose={() => handleClickRadio(attribute, attr, attrIndex)}
                />
              </div>
            ))}
          </div>
        )}

        {isCheckbox() && (
          <div className="item-content-radio-wrap">
            {attribute.categoryAttributeValueList?.map((attr, attrIndex) => (
              <div className="radio-item" key={attrIndex}>
                <CheckButton
                  name={attr.attributeValue}
                  active={attr.active}
                  choose={() => handleClickCheckbox(attrIndex)}
                />
              </div>
            ))}
          </div>
        )}
        {(isTEXT() || isFloat() || isInt()) && (
          <div className="input-wrap">
            <Input
              className="input"
              value={inputVal || ""}
              type={inputType()}
              placeholder="请输入"
              prefix={attribute.categoryAttributeValueList[0]?.prefix}
              suffix={attribute.categoryAttributeValueList[0]?.suffix}
              onChange={(val) => {
                handleChangeInput(
                  val.target.value,
                  attribute.categoryAttributeValueList[0],
                )
              }}
              onBlur={() => {
                handleBlur()
              }}
            />
          </div>
        )}
      </div>
      <style jsx>{`
        .item-wrap {
          line-height: 1;
          font-size: 12px;
          display: flex;
          overflow: hidden;
          align-items: flex-start;
        }
        .item-wrap:first-child {
          margin-top: 15px;
        }
        .item-label {
          font-size: 14px;
          color: #333333;
          min-width: 80px;
          text-align: right;
          padding-right: 10px;
          margin-top: 10px;
        }
        .item-content {
        }
        .item-content-radio-wrap {
          display: flex;
          width: 280px;
          flex-wrap: wrap;
        }
        .radio-item {
          display: inline-block;
          vertical-align: middle;
          margin-right: 10px;
          margin-bottom: 10px;
        }
        .radio-item:last-child {
          margin-right: 0;
        }

        .input-wrap {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        }
        .input-wrap :global(.input) {
          width: 148px;
          height: 32px;
          align-items: center;
          padding: 0 5px;
        }
        .input-wrap :global(.input .rv-field__control) {
          text-align: center;
          font-size: 12px;
        }
        .input-prefix {
          margin-right: 10px;
        }
        .input-suffix {
          margin-left: 10px;
        }
        .checkbox-wrap {
          display: flex;
          flex-wrap: wrap;
          margin-top: -4px;
        }
      `}</style>
    </div>
  )
}
